import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { cn } from "@/utils/cn";
import { useUserByEmail } from "@/services/settings";
import deloitteLogo from "@/imgs/Deloitte Logo.svg";
import questionIcon from "@/imgs/Question.png";
import { env } from "@/config/env";

const navItems = [
  { label: "Dashboard", href: "/dashboard", permission: "CanViewDashboard" },
  { label: "GRC", href: "/grcdashboard", permission: "CanViewGRCReport" },
  { label: "Draft Calendar", href: "/draftcalendar", permission: "CanViewDraftCalender" },
  { label: "Settings", href: "/settings", permission: "CanViewSettings" },
  { label: "Message Log", href: "/message-monitor", permission: "CanViewMessageLog" }
];

export function Header() {
  const [showHelpMenu, setShowHelpMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const location = useLocation();
  const { accounts, instance } = useMsal();
  const email = accounts[0]?.username ?? "";

  const { data: user } = useUserByEmail(email, {
    enabled: Boolean(email),
  });

  const userPermissions = user?.permissions ?? [];
  const allowedNavItems = navItems.filter((item) => userPermissions.includes(item.permission));

  const roleName = user?.roleName?.toLowerCase() ?? "";
  const isApproverRole = roleName === "approver" || roleName === "businessreviewer";
  const userGuideUrl = isApproverRole
    ? (env.VITE_APPROVER_USER_GUIDE_URL ?? "")
    : (env.VITE_ADMIN_USER_GUIDE_URL ?? "");

  const profileInitial = (user?.firstName?.[0] ?? user?.name?.[0] ?? "M").toUpperCase();

  function handleLogOut() {
    void instance.logoutRedirect();
  }

  return (
    <header className="app-header-react">
      <div className="menu-left-react">
        <div className="logo-menu-react">
          <img
            src={deloitteLogo}
            alt="Deloitte"
            className="deloitte-logo-react"
          />
        </div>
        <div className="application-menu-react">
          <div className="application-sub-title-container-react">
            <div className="application-sub-title-react">
              <span className="bar">|</span>
              <span className="application-name">Mable</span>
            </div>
          </div>
          <nav className="header-nav-react" aria-label="Primary">
            {allowedNavItems.map((item) => {
              const isActive =
                (item.href === "/dashboard"
                  ? location.pathname === "/" || location.pathname.startsWith("/dashboard")
                  : location.pathname === item.href ||
                    location.pathname.startsWith(`${item.href}/`));

              return (
                <NavLink key={item.label} to={item.href} className="header-tab-link">
                  <span
                    className={cn(
                      "header-tab-menu-container-react",
                      isActive && "active-link-text-react"
                    )}
                  >
                    <span className="header-tab-title-react">{item.label}</span>
                  </span>
                </NavLink>
              );
            })}
          </nav>
        </div>
      </div>

      <div className="menu-right-react">
        <div className="header-container-react">
          <div className="question-menu-react">
            <button
              type="button"
              className="icon-button-react"
              onClick={() => {
                setShowHelpMenu((open) => !open);
                setShowUserMenu(false);
              }}
              aria-expanded={showHelpMenu}
              aria-haspopup="menu"
              aria-label="Have a question"
            >
              <div className="logo" style={{ justifyContent: "center" }}>
                <img style={{ height: "35px", paddingLeft: "10px" }} src={questionIcon} alt="" />
              </div>
            </button>
            {showHelpMenu ? (
              <div className="question-dropdown-react" role="menu">
                <a target="_blank" rel="noopener noreferrer" href={userGuideUrl}>
                  User Guide
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={env.VITE_LOG_ISSUE_URL ?? ""}
                >
                  Log an Issue
                </a>
              </div>
            ) : null}
          </div>

          <div className="user-menu-anchor-react">
            <button
              type="button"
              className="profile-button-react"
              onClick={() => {
                setShowUserMenu((open) => !open);
                setShowHelpMenu(false);
              }}
              aria-expanded={showUserMenu}
              aria-haspopup="menu"
              aria-label="User menu"
            >
              <span className="profile-avatar-react">{profileInitial}</span>
            </button>
            {showUserMenu ? (
              <div className="user-menu-react" role="menu">
                <button type="button" className="user-menu-item-react" onClick={handleLogOut}>
                  Log Out
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </header>
  );
}
